/* import __COLOCATED_TEMPLATE__ from './action-link.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { type SafeString } from '@ember/template/-private/handlebars';
import type { ActionLink } from './action';

interface Signature {
  Args: {
    actionLink: ActionLink;
    translationKey: string;
  };
  Element: HTMLAnchorElement;
  Blocks: {
    default: [];
  };
}

const AnswerNoticeActionLinkComponent = class extends Component<Signature> {
  get actionLink(): SafeString {
    return sanitizeHtml(
      `<a href="${this.args.actionLink.url}" target="_blank" class="fin-playground__answer-notice__content__link">${this.args.actionLink.name}</a>`,
    );
  }
};
export default AnswerNoticeActionLinkComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::FinAnswer::AnswerNotice::ActionLink': typeof AnswerNoticeActionLinkComponent;
    'ai-agent/playground/fin-answer/answer-notice/action-link': typeof AnswerNoticeActionLinkComponent;
  }
}
